import React from 'react'
import Create from '../crud/create'
import fields from './fields'

const CreateSession = (props) => {
  return (
    <Create
// @ts-ignore
      title='Create Session'
      fields={fields}
      apiPath='admin/sessions'
      successRedirectPath={resource => `/write-now/sessions/${resource.id}/edit`}
    />
  )
}

export default CreateSession
